import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var cancelTrainingRes;
export const cancelTrainingTodo = createAsyncThunk('cancelTraining', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(id)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/cancel_training',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "training_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return cancelTrainingRes = res.data
    } catch (error) {
        return cancelTrainingRes = error.response.data
    }
})